<div
  class="flex h-screen w-full items-center justify-center bg-white dark:bg-vivid-royal-950"
>
  <div class="w-full max-w-md px-6 py-10">
    <!-- Logo -->
    <div class="mb-8 text-center">
      <img
        src="./assets/logos/energo_logo.svg"
        class="mx-auto w-40 dark:hidden"
        alt="Logo"
      />
      <img
        src="./assets/logos/energo_logo_dark.svg"
        class="mx-auto w-40 hidden dark:block"
        alt="Logo"
      />
    </div>
    <div class="text-center space-y-4">
      <div
        class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto"
      >
        <i class="pi pi-exclamation-triangle text-3xl text-red-500"></i>
      </div>
      <h1
        class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100"
      >
        No se pudo conectar con el servidor
      </h1>
      <p class="text-sm text-vivid-royal-400 leading-relaxed">
        No fue posible conectar con nuestros servicios. Esto puede deberse a:
      </p>
      <ul class="text-sm text-vivid-royal-400 text-left space-y-1 pl-4">
        <li>• Su red o firewall está bloqueando el acceso al portal.</li>
        <li>• Conexión a internet intermitente.</li>
        <li>• Mantenimiento temporal del servicio.</li>
      </ul>
      <div class="bg-vivid-royal-50 dark:bg-vivid-royal-900 rounded-lg p-3 text-left">
        <p class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1">¿Su empresa usa firewall o VPN?</p>
        <p class="text-xs text-vivid-royal-400">Solicite a su departamento de TI que permita el acceso al dominio del portal en su red corporativa.</p>
      </div>
      <button pButton label="Reintentar conexión" icon="pi pi-refresh" class="p-button-sm w-full" (click)="checkStatus()"></button>
    </div>
  </div>
</div>
